import React from 'react'
import { Card, ListGroup } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import useRecentSearches from 'hooks/use-recent-searches'
import useRecentUsers from 'hooks/use-recent-users'

const UsersSidebar: React.FC = () => {
  const history = useHistory()
  const { recentSearches } = useRecentSearches()
  const { recentUsers } = useRecentUsers()

  const handleSearchClick = (query: string) => {
    history.push(`/users?query=${encodeURIComponent(query)}`)
  }

  const handleUserClick = (userId: number) => {
    history.push(`/user/${userId}`)
  }

  return (
    <div className="users-sidebar">
      <Card className="mb-3">
        <Card.Header className="text-light" style={{ backgroundColor: '#444' }}>
          <h6 className="mb-0">Your Recent User Searches</h6>
        </Card.Header>
        <Card.Body className="p-0">
          {recentSearches.length === 0 ? (
            <div className="text-muted p-3">
              <small>No recent searches</small>
            </div>
          ) : (
            <ListGroup variant="flush">
              {recentSearches.slice(0, 5).map((search, index) => (
                <ListGroup.Item
                  key={index}
                  className="d-flex align-items-center justify-content-between"
                  action
                  onClick={() => handleSearchClick(search.query)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="text-truncate">{search.query}</span>
                  <ion-icon
                    name="search-outline"
                    style={{ fontSize: '16px' }}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Header className="text-light" style={{ backgroundColor: '#444' }}>
          <h6 className="mb-0">Recently Viewed Users</h6>
        </Card.Header>
        <Card.Body className="p-0">
          {recentUsers.length === 0 ? (
            <div className="text-muted p-3">
              <small>No recently viewed users</small>
            </div>
          ) : (
            <ListGroup variant="flush">
              {recentUsers.map((user) => (
                <ListGroup.Item
                  key={user.id}
                  className="d-flex align-items-center justify-content-between"
                  action
                  onClick={() => handleUserClick(user.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="text-truncate">
                    <div className="fw-bold">{user.name}</div>
                    <small className="text-muted">{user.email}</small>
                  </div>
                  <ion-icon
                    name="chevron-forward-outline"
                    style={{ fontSize: '16px' }}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}

export default UsersSidebar
